module.exports = __webpack_public_path__ + "static/media/cirque-du-celeste-2.b549479d.jpg";